import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDecimalLimit]'
})
export class DecimalLimitDirective {

  private regex: RegExp = new RegExp(/^\d+(\.\d{0,5})?$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow special keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    // Get the current value of the input
    const current: string = this.el.nativeElement.value;
    // Get the position of the cursor
    const position: number = this.el.nativeElement.selectionStart;
    // Get the value of the input if we apply the key that was pressed
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    
    // Check if the new value matches the regex
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}